import { Modal } from "flowbite-react";
import React, { useState, useRef } from "react";
import { couponVide } from "../../assets/images";
import { useTranslation } from "react-i18next";
import CopyBtn from "./CopyBtn";
import { FormatDateForCoupon } from "../../elements/FormatDate";
import i18next from "i18next";

const CouponDiv = ({ percentage, code, validUntil }) => {
  const { t } = useTranslation();
  const canvasRef = useRef(null);

  const drawImage = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const image = new Image();
    console.log("date : " + validUntil);
    image.src = couponVide;

    image.onload = () => {
      canvas.width = image.width;
      canvas.height = image.height;
      ctx.drawImage(image, 0, 0);

      ctx.font = "500 220px 'Anton', sans-serif";
      ctx.fillStyle = "#1C64F2";
      ctx.textAlign = "center";
      ctx.save();
      ctx.translate(380, canvas.height / 2);
      ctx.rotate(-Math.PI / 2);
      ctx.fillText(`${percentage}`, 0, 0);
      ctx.restore();

      ctx.font = "600 30px Poppins";
      ctx.fillStyle = "#1C64F2";
      ctx.textAlign = "center";
      ctx.save();
      ctx.translate(160, canvas.height / 2);
      ctx.rotate(-Math.PI / 2);
      ctx.fillText(t("purchase-coupon"), 0, 0);
      ctx.restore();

      ctx.font = "500 25px Poppins";
      ctx.fillStyle = "#fff";
      ctx.fillText(`${t("valid-until")} ${FormatDateForCoupon(validUntil, i18next.language)}`, 900, 510);

      // Add another normal text
      ctx.font = "600 30px Poppins";
      ctx.fillStyle = "white";
      ctx.fillText("SHOP.SHAREDSTORE.MA", 900, 160);
      ctx.font = "600 45px Poppins";
      ctx.fillStyle = "whte";
      ctx.fillText(`Code ${code}`, 900, 470);
    };
  };

  React.useEffect(() => {
    drawImage();
  }, [percentage, code, validUntil]);

  return (
    <div style={{ textAlign: "center" }}>
      <canvas ref={canvasRef} style={{ maxWidth: "100%" }} />
    </div>
  );
};

const CouponCard = ({ discountValue, codeValue, endDateValue }) => {
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(false);

  // Move handleDownload here
  const handleDownload = () => {
    const canvas = document.querySelector('canvas');
    const link = document.createElement("a");
    link.download = "coupon.png";
    link.href = canvas.toDataURL("image/png");
    link.click();
  };

  return (
    <div>
      <button onClick={() => setOpenModal(true)} className="myborder px-2 py-1.5 font-semibold text-black text-sm rounded-md bg-white hover:bg-gray-100">
        {t("view")}
      </button>
      <Modal show={openModal} onClose={() => setOpenModal(false)} size="2xl">
        <Modal.Header className="py-2 px-3"></Modal.Header>
        <Modal.Body className="p-4">
          <CouponDiv percentage={discountValue} code={codeValue} validUntil={endDateValue} />
        </Modal.Body>
        <Modal.Footer className="py-3 px-4 flex justify-center">
          <button onClick={handleDownload} className="myborder px-3 py-2 font-semibold text-blue-700 text-sm rounded-md hover:bg-blue-100">
            {t("download-coupon")}
          </button>
          <CopyBtn value={codeValue} />
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CouponCard;
